import { ApiResult } from 'interfaces/APITypes';
import { ArticleOptions, ArticleParams } from 'interfaces/ArticleTypes';

import { makeRequest, mytoverInstance } from './client';

export const getMenu = async (): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/menu'));
};

export const getLocales = async (): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/locales'));
};

export const getArticles = async (options?: ArticleOptions): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/articles', { params: options }));
};

export const getFeaturedArticles = async (): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/articles/featured'));
};

export const getArticle = async (
  id: string,
  locale: string | null = null,
  withTranslations: boolean = false,
): Promise<ApiResult> => {
  const params: ArticleParams = {};
  if (locale) {
    params.locale = locale;
  }
  if (withTranslations) {
    params.with_translations = withTranslations;
  }
  // A refused article is explained on the article page itself (sign in, or the My Tover
  // service is missing), so it must not be swallowed by the global 403 redirect.
  return makeRequest(mytoverInstance.get(`/articles/${id}`, { params, handleErrorInPage: true }));
};

export const updateArticle = async (id: string, data: any): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.patch(`/articles/${id}`, { ...data }));
};

export const refreshArticle = async (id: number, now = false): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post(`/articles/${id}/refresh`, { now }));
};

export const refreshArticles = async (now = false): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post('/articles/refresh', { now }));
};

export const getAttachment = async (id: string, filename: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/articles/${id}/${filename}`));
};

export const getCategories = async (): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/categories'));
};

export const getCategory = async (id: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/categories/${id}`));
};

export const getContent = async (content: string, locale: string | null = null): Promise<ApiResult> => {
  const params: ArticleParams = {};
  if (locale) {
    params.locale = locale;
  }
  return makeRequest(mytoverInstance.get(`/content/${content}`, { params, handleErrorInPage: true }));
};

export const getSoftwareUpdate = async (version: string): Promise<ApiResult> => {
  // No update package for this tovertafel version is an expected, in-page outcome (the section
  // just renders nothing - see SoftwareDownloadSection) - not an app-wide error to redirect away from.
  return makeRequest(
    mytoverInstance.get(`/downloads/software_updates/${version}?link=true`, { handleErrorInPage: true }),
  );
};

export const getConfigurationLink = async (serial: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/downloads/configuration/${serial}`));
};
